export const deCollator = new Intl.Collator('de', {
  sensitivity: 'base',
  numeric: true,
});
